import { Icon } from "@repo/ui/components/icon";
import { Button } from "@repo/ui/ui/button";
import { Card, CardContent } from "@repo/ui/ui/card";
import { createLink, useNavigate } from "@tanstack/react-router";

import { SettingsHeader } from "~/pages/settings-header";
import { DatasourceNewForm } from "./datasource-new.form";

const ButtonLink = createLink(Button);

export const DatasourceNewPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <SettingsHeader
        title="Add datasource"
        description="Connect a new data source to start querying your data."
      >
        <ButtonLink to="/settings/datasources" variant="ghost">
          <Icon name="chevron-left" />
          Back
        </ButtonLink>
      </SettingsHeader>

      <Card>
        <CardContent className="flex min-h-96 flex-col">
          <DatasourceNewForm
            onCreated={(_datasourceId) => {
              navigate({ to: "/settings/datasources" });
            }}
            secondaryAction={
              <ButtonLink to="/settings/datasources" variant="ghost">
                Cancel
              </ButtonLink>
            }
          />
        </CardContent>
      </Card>

      <p className="text-center text-muted-foreground text-xs">
        Need something specific?{" "}
        <a
          href="mailto:support@mora.com"
          className="underline underline-offset-4 hover:text-foreground"
        >
          Let us know
        </a>
      </p>
    </>
  );
};
